class LocalizationService{
    constructor(client){
        this.apiClient = client;
    }
    async getAllLanguages(){
        return await this.apiClient.get(`locales`);
    }
}
export default LocalizationService;